import * as React from 'react';
import spanishLocale from 'date-fns/locale/es';
import englishLocale from 'date-fns/locale/en-US';

// i18n
import i18n from '../i18n';

const Locales = {
    en: englishLocale,
    es: spanishLocale
};

// If language is not "pure" (ie. 'en' as opposed to 'en-US' / 'en-GB'), get parent language
export const useCurrentParentLanguage = () => {
    const parentLanguage = React.useMemo(() => i18n.language.split('-')[0], [i18n?.language]) as 'es' | 'en';

    return {
        code: parentLanguage,
        locale: Locales[parentLanguage]
    };
};

export default useCurrentParentLanguage;
